import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Admin.css";
import { adminApi } from "../services/api";
import AdminPieChart from "./AdminPieChart";

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [activeUsers, setActiveUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [analytics, sessions] = await Promise.all([
          adminApi.analytics(),
          adminApi.activeUsers(),
        ]);
        if (cancelled) return;
        setStats(analytics.data);
        setActiveUsers(sessions.data || []);
      } catch (err) {
        if (!cancelled) setError(err.message || "Failed to load analytics");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    const interval = setInterval(async () => {
      try {
        const sessions = await adminApi.activeUsers();
        setActiveUsers(sessions.data || []);
      } catch {
        /* ignore */
      }
    }, 60000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  const totals = stats?.totals || {};

  return (
    <div className="admin-dashboard">
      {error && <p className="admin-error">{error}</p>}
      <div className="admin-stats">
        <div className="admin-stat-card">
          <h3>Cars</h3>
          <p>{loading ? "…" : totals.cars ?? 0}</p>
        </div>
        <div className="admin-stat-card">
          <h3>Brands</h3>
          <p>{loading ? "…" : totals.brands ?? 0}</p>
        </div>
        <div className="admin-stat-card">
          <h3>Users</h3>
          <p>{loading ? "…" : totals.users ?? 0}</p>
        </div>
        <div className="admin-stat-card">
          <h3>Partners</h3>
          <p>{loading ? "…" : totals.partners ?? 0}</p>
        </div>
        <div className="admin-stat-card">
          <h3>Modified</h3>
          <p>{loading ? "…" : totals.modified ?? 0}</p>
        </div>
        <div className="admin-stat-card">
          <h3>Projects</h3>
          <p>{loading ? "…" : totals.projects ?? 0}</p>
        </div>
      </div>

      <div className="admin-charts-grid">
        <AdminPieChart title="Cars by status" data={stats?.carsByStatus || []} />
        <AdminPieChart title="Users by role" data={stats?.usersByRole || []} />
      </div>

      <div className="admin-panel admin-active-users">
        <div className="admin-panel-head">
          <h2>Active users (last 5 min)</h2>
          <span className="admin-badge">{activeUsers.length}</span>
        </div>
        {loading ? (
          <div className="admin-loading">Loading…</div>
        ) : activeUsers.length === 0 ? (
          <div className="admin-empty">No active sessions right now.</div>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Last seen</th>
                </tr>
              </thead>
              <tbody>
                {activeUsers.map((u) => (
                  <tr key={u._id || u.userId}>
                    <td>{u.name || "—"}</td>
                    <td>{u.email}</td>
                    <td>
                      <span className={`admin-role-pill role-${u.role}`}>{u.role}</span>
                    </td>
                    <td>{new Date(u.lastSeen).toLocaleTimeString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="admin-panel">
        <div className="admin-panel-head">
          <h2>Quick links</h2>
        </div>
        <div className="admin-quick-links">
          <Link to="/admin/cars" className="admin-btn admin-btn-secondary">
            Manage Cars
          </Link>
          <Link to="/admin/brands" className="admin-btn admin-btn-ghost">
            Brands
          </Link>
          <Link to="/admin/users" className="admin-btn admin-btn-ghost">
            Users
          </Link>
          <Link to="/admin/notifications" className="admin-btn admin-btn-ghost">
            Notifications
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
